
            const data = {"name":"right","data":{"width":"10","height":"16","viewBox":"0 0 10 16","data":"<path pid=\"0\" d=\"M8.921 8.53l-6.073 6.074a.75.75 0 01-1.06 0l-.709-.709a.75.75 0 01-.001-1.06L5.89 8 1.078 3.164a.75.75 0 01.001-1.06l.708-.708a.75.75 0 011.061 0L8.921 7.47a.75.75 0 010 1.06z\" _fill=\"currentColor\"/>"}}
        
                module.exports = data
                